// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContainerScannerModal_backdrop__F83qI {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.ContainerScannerModal_dialog__qN2hS {
  background: #fff;
  border-radius: 10px;
  width: 94%;
  max-width: 480px;
  max-height: 94%;
  padding: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.25);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: auto;
}

.ContainerScannerModal_closeBtn__8wUyy {
  position: absolute;
  top: 8px;
  right: 12px;
  background: none;
  border: none;
  font-size: 1.3rem;
  cursor: pointer;
  color: #666;
  transition: color 0.2s;
}
.ContainerScannerModal_closeBtn__8wUyy:hover {
  color: #000;
}

.ContainerScannerModal_title__OFIOq {
  margin: 0 0 10px;
  font-size: 1.1rem;
  text-align: center;
  font-weight: 600;
}

.ContainerScannerModal_info__JxI0n {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 10px;
  font-size: 0.8rem;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.ContainerScannerModal_rowsInfo__aBwZ\\+ {
  margin-top: 6px;
  font-size: 0.75rem;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.ContainerScannerModal_rowsInfo__aBwZ\\+ strong {
  display: block;
  margin-bottom: 4px;
}

.ContainerScannerModal_rowsInfo__aBwZ\\+ ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.ContainerScannerModal_rowsInfo__aBwZ\\+ li {
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 4px;
}

.ContainerScannerModal_rowsInfo__aBwZ\\+ li.ContainerScannerModal_fullRow__mWYEc {
  background: #e6ffe6 !important;
  border: 1px solid #00aa00 !important;
}

.ContainerScannerModal_rowLabel__1cU3B {
  font-size: 0.72rem;
  margin-bottom: 3px;
}

.ContainerScannerModal_progressBar__3z515 {
  position: relative;
  background: #e5e5e5;
  border-radius: 3px;
  height: 5px;
  overflow: hidden;
}
.ContainerScannerModal_progressFill__Y3hva {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #4caf50;
  transition: width 0.3s ease;
}

.ContainerScannerModal_rowSelector__oxaBi {
  margin: 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ContainerScannerModal_rowSelector__oxaBi label {
  font-size: 0.8rem;
  margin-right: 6px;
}

.ContainerScannerModal_rowSelector__oxaBi select {
  padding: 2px 6px;
  font-size: 0.8rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
}




.ContainerScannerModal_scannerWrapper__M4N3X {
  width: 85%;
  max-width: 240px;
  aspect-ratio: 1/1;
  margin: 10px auto;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ContainerScannerModal_error__w3WlE,
.ContainerScannerModal_success__\\+oM26 {
  font-size: 0.8rem;
  font-weight: 600;
  margin: 4px 0;
  text-align: center;
}

.ContainerScannerModal_error__w3WlE {
  color: #c00;
}
.ContainerScannerModal_success__\\+oM26 {
  color: #0a0;
}

.ContainerScannerModal_controlsRow__mPX7X {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin: 8px 0;
}

.ContainerScannerModal_controlGroup__KH6bD {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f7f7f7;
  padding: 4px 6px;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.ContainerScannerModal_controlGroup__KH6bD label {
  font-size: 0.78rem;
  margin-right: 4px;
  white-space: nowrap;
}

.ContainerScannerModal_controlGroup__KH6bD select {
  flex: 1 1;
  padding: 2px 4px;
  font-size: 0.78rem;
  border: none;
  background: transparent;
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Storekeeper/ContainersPage/ContainerScannerModal/ContainerScannerModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;;;;AAKA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,aAAa;AACf","sourcesContent":[".backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0,0,0,0.45);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.dialog {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  width: 94%;\r\n  max-width: 480px;\r\n  max-height: 94%;\r\n  padding: 12px;\r\n  box-shadow: 0 4px 16px rgba(0,0,0,0.25);\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  overflow-y: auto;\r\n}\r\n\r\n.closeBtn {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 12px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.3rem;\r\n  cursor: pointer;\r\n  color: #666;\r\n  transition: color 0.2s;\r\n}\r\n.closeBtn:hover {\r\n  color: #000;\r\n}\r\n\r\n.title {\r\n  margin: 0 0 10px;\r\n  font-size: 1.1rem;\r\n  text-align: center;\r\n  font-weight: 600;\r\n}\r\n\r\n.info {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 6px 10px;\r\n  font-size: 0.8rem;\r\n  margin-bottom: 8px;\r\n  padding-bottom: 8px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.rowsInfo {\r\n  margin-top: 6px;\r\n  font-size: 0.75rem;\r\n  padding-bottom: 8px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.rowsInfo strong {\r\n  display: block;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.rowsInfo ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 6px;\r\n}\r\n\r\n.rowsInfo li {\r\n  background: #fafafa;\r\n  border: 1px solid #eee;\r\n  border-radius: 6px;\r\n  padding: 4px;\r\n}\r\n\r\n.rowsInfo li.fullRow {\r\n  background: #e6ffe6 !important;\r\n  border: 1px solid #00aa00 !important;\r\n}\r\n\r\n.rowLabel {\r\n  font-size: 0.72rem;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.progressBar {\r\n  position: relative;\r\n  background: #e5e5e5;\r\n  border-radius: 3px;\r\n  height: 5px;\r\n  overflow: hidden;\r\n}\r\n.progressFill {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  background: #4caf50;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.rowSelector {\r\n  margin: 8px 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.rowSelector label {\r\n  font-size: 0.8rem;\r\n  margin-right: 6px;\r\n}\r\n\r\n.rowSelector select {\r\n  padding: 2px 6px;\r\n  font-size: 0.8rem;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n}\r\n\r\n\r\n\r\n\r\n.scannerWrapper {\r\n  width: 85%;\r\n  max-width: 240px;\r\n  aspect-ratio: 1/1;\r\n  margin: 10px auto;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.error,\r\n.success {\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  margin: 4px 0;\r\n  text-align: center;\r\n}\r\n\r\n.error {\r\n  color: #c00;\r\n}\r\n.success {\r\n  color: #0a0;\r\n}\r\n\r\n.controlsRow {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  margin: 8px 0;\r\n}\r\n\r\n.controlGroup {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background: #f7f7f7;\r\n  padding: 4px 6px;\r\n  border-radius: 6px;\r\n  border: 1px solid #ddd;\r\n}\r\n\r\n.controlGroup label {\r\n  font-size: 0.78rem;\r\n  margin-right: 4px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.controlGroup select {\r\n  flex: 1;\r\n  padding: 2px 4px;\r\n  font-size: 0.78rem;\r\n  border: none;\r\n  background: transparent;\r\n  outline: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `ContainerScannerModal_backdrop__F83qI`,
	"dialog": `ContainerScannerModal_dialog__qN2hS`,
	"closeBtn": `ContainerScannerModal_closeBtn__8wUyy`,
	"title": `ContainerScannerModal_title__OFIOq`,
	"info": `ContainerScannerModal_info__JxI0n`,
	"rowsInfo": `ContainerScannerModal_rowsInfo__aBwZ+`,
	"fullRow": `ContainerScannerModal_fullRow__mWYEc`,
	"rowLabel": `ContainerScannerModal_rowLabel__1cU3B`,
	"progressBar": `ContainerScannerModal_progressBar__3z515`,
	"progressFill": `ContainerScannerModal_progressFill__Y3hva`,
	"rowSelector": `ContainerScannerModal_rowSelector__oxaBi`,
	"scannerWrapper": `ContainerScannerModal_scannerWrapper__M4N3X`,
	"error": `ContainerScannerModal_error__w3WlE`,
	"success": `ContainerScannerModal_success__+oM26`,
	"controlsRow": `ContainerScannerModal_controlsRow__mPX7X`,
	"controlGroup": `ContainerScannerModal_controlGroup__KH6bD`
};
export default ___CSS_LOADER_EXPORT___;
